import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { OnboardingRegistration } from '@/common/models';
import { RegistrationsHelper } from '@/common/helpers';
import { OnboardingRegistrationStatus } from '@/common/viewModels/Enums';

@Component({
  components: {
  },
})
export default class RegistrationDetailsInfo extends Vue {

  @Prop({ required: true }) onboardingRegistration!: OnboardingRegistration;

  onboardingRegistrationStatus: typeof OnboardingRegistrationStatus = OnboardingRegistrationStatus;

  get submittedMessage(): string {
    return this.onboardingRegistration ?
      `Submitted by ${this.onboardingRegistration.submittedBy} on ${RegistrationsHelper.formatDate(this.onboardingRegistration.createdAtUtc.toString())}` : '';
  }

  get completedMessage(): string {
    return this.onboardingRegistration ? `Completed on ${RegistrationsHelper.formatDate(this.onboardingRegistration.modifiedAtUtc.toString())}` : '';
  }

  get cancelledMessage(): string {
    return this.onboardingRegistration ? `Cancelled by ${this.onboardingRegistration.modifiedBy} on ${RegistrationsHelper.formatDate(this.onboardingRegistration.modifiedAtUtc.toString())}` : '';
  }

  get showSubmitted(): boolean {
    return this.onboardingRegistration.status !== OnboardingRegistrationStatus.Cancelled;
  }

}
